<template>
  <div>
    <!-- <h1>{{ msg }}</h1>
    <p>
      This is mounting to Webflow correctly.
    </p>
    <h3>Installed CLI Plugins</h3> -->
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
